// MUTATIONS
export const SET_IS_ACTIVE_REQUEST = 'setIsActiveRequest';
export const SET_SELECTED_CATEGORY_ID = 'setSelectedCategoryId';
export const SET_CURRENT_DOCUMENT = 'setCurrentDocument';
export const SET_IS_LOADING = 'setIsLoading';

// ACTIONS
export const ACTION_GET_DOCUMENT = 'getDocument';
export const ACTION_ADD_DOCUMENT = 'addDocument';
export const ACTION_UPDATE_DOCUMENT = 'updateDocument';
export const ACTION_REMOVE_DOCUMENT = 'removeDocument';
export const ACTION_FINISH_TEST = 'finishTest';

// GETTERS
export const GET_IS_ACTIVE_REQUEST = 'isActiveRequest';
export const GET_CURRENT_DOCUMENT = 'currentDocument';
export const GET_IS_LOADING = 'isLoading';